import { useState } from 'react';
import type { Category } from '../types';

interface SearchFiltersProps {
  categories: Category[];
  onSearch: (filters: {
    name: string;
    categoryId: number | null;
    isOnline: string;
    cpuCores: number | null;
    memory: number | null;
    gpu: string;
  }) => void;
}

export default function SearchFilters({ categories, onSearch }: SearchFiltersProps) {
  const [name, setName] = useState('');
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [isOnline, setIsOnline] = useState('all');
  const [cpuCores, setCpuCores] = useState<number | null>(null);
  const [memory, setMemory] = useState<number | null>(null);
  const [gpu, setGpu] = useState('');

  const handleSearch = () => {
    onSearch({ name, categoryId, isOnline, cpuCores, memory, gpu });
  };

  const handleReset = () => {
    setName('');
    setCategoryId(null);
    setIsOnline('all');
    setCpuCores(null);
    setMemory(null);
    setGpu('');
    onSearch({ name: '', categoryId: null, isOnline: 'all', cpuCores: null, memory: null, gpu: '' });
  };

  return (
    <div className="bg-white rounded-lg p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">商品名称</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="请输入商品名称"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">商品分类</label>
          <select
            value={categoryId || ''}
            onChange={(e) => setCategoryId(e.target.value ? Number(e.target.value) : null)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          >
            <option value="">全部分类</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">是否上架</label>
          <select
            value={isOnline}
            onChange={(e) => setIsOnline(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          >
            <option value="all">全部</option>
            <option value="online">已上架</option>
            <option value="offline">已下架</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">CPU核心数</label>
          <select
            value={cpuCores || ''}
            onChange={(e) => setCpuCores(e.target.value ? Number(e.target.value) : null)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          >
            <option value="">全部</option>
            <option value="2">2核</option>
            <option value="4">4核</option>
            <option value="8">8核</option>
            <option value="16">16核</option>
            <option value="32">32核</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">内存容量</label>
          <select
            value={memory || ''}
            onChange={(e) => setMemory(e.target.value ? Number(e.target.value) : null)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          >
            <option value="">全部</option>
            <option value="4">4GB</option>
            <option value="8">8GB</option>
            <option value="16">16GB</option>
            <option value="32">32GB</option>
            <option value="64">64GB</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">GPU型号</label>
          <select
            value={gpu}
            onChange={(e) => setGpu(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
          >
            <option value="">全部</option>
            <option value="T4">T4</option>
            <option value="5070">5070</option>
            <option value="5090">5090</option>
          </select>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={handleReset}
          className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap"
        >
          重置
        </button>
        <button
          onClick={handleSearch}
          className="px-6 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors whitespace-nowrap"
        >
          搜索
        </button>
      </div>
    </div>
  );
}
